/* globals angular, EventSource */
(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/data/stats', {
      templateUrl: 'modules/app/data/stats/stats.html',
      controller: 'StatsCtrl',
      requiredPermissions: ['admin']
    });
  }]).controller('StatsCtrl', ['$scope', '$http', '$timeout', 'Api', 'OrganizationSettings', function ($scope, $http, $timeout, Api, OrganizationSettings) {
    var GROUP_STATS_EVENT = "STATS:GROUP_STATS_EVENT";
    var DATA_SOURCE_STATS_EVENT = "STATS:DATA_SOURCE_STATS";
    $scope.section = "stats";
    function loadStats() {
      $scope.longWait = false;
      $scope.statsLoaded = false;
      $scope.dataSourceStats = [];
      $scope.groupStats = {};
      $timeout(function () {
        $scope.longWait = true;
      }, 750);
      var source = new EventSource(Api.url('/data-stats'));
      source.addEventListener(GROUP_STATS_EVENT, function (evt) {
        $scope.groupStats = JSON.parse(evt.data);
        if (!OrganizationSettings.hasFeature('exactDistinctCountDataStats')) {
          var DEFAULT_ES_PRECISION_THRESHOLD = 3000;
          // 3000 is the default precision threshold for ES queries
          if ($scope.groupStats.peopleWithStatements > DEFAULT_ES_PRECISION_THRESHOLD) {
            $scope.groupStats.peopleWithStatements = Math.round($scope.groupStats.peopleWithStatements / 100) * 100;
            $scope.groupStats.peopleWithoutStatements = Math.round($scope.groupStats.peopleWithoutStatements / 100) * 100;
            $scope.groupStats.peopleWithStatementsApproximate = true;
          }
          if ($scope.groupStats.groupsWithStatements > DEFAULT_ES_PRECISION_THRESHOLD) {
            $scope.groupStats.groupsWithStatements = Math.round($scope.groupStats.groupsWithStatements / 100) * 100;
            $scope.groupStats.groupsWithoutStatements = Math.round($scope.groupStats.groupsWithoutStatements / 100) * 100;
            $scope.groupStats.groupsWithStatementsApproximate = true;
          }
        }
        $scope.$apply();
      });
      source.addEventListener(DATA_SOURCE_STATS_EVENT, function (evt) {
        $scope.dataSourceStats.push(JSON.parse(evt.data));
        $scope.$apply();
      });
      source.onerror = function () {
        // If the connection is closed
        if (source.readyState !== source.OPEN) {
          source.close();
          $scope.statsLoaded = true;
          $scope.$apply();
        }
      };
      OrganizationSettings.get().then(function (orgSettings) {
        $scope.orgSettings = orgSettings;
        $scope.essentialsTier = orgSettings.pricingTier === "ESSENTIALS";
      });
    }
    loadStats();
  }]);
})();
